export const JEBBIT_URL =
  'https://quiz.simplisafe.com/kaedkhe4?L=Full+Page&deferred=true'

export const JEBBIT_URL_UK =
  'https://quiz.simplisafe.com/08odhevq?L=Full+Page&deferred=true'
